const enableNode = document.querySelector( '#wcbt_sale_notice_enable' );
const productTypeNode = document.querySelector( '#wcbt_product_type' );
const saleProductNode = document.querySelector( '#wcbt_sale_product_order' );
const saleProductNumberNode = document.querySelector( '#wcbt_sale_product_number' );
const virtualProductNode = document.querySelector( '#wcbt_virtual_product' );
const virtualUserNode = document.querySelector( '#wcbt_virtual_user' );

const wcbtSaleNotice = () => {
	enableField();
	insertVariableToMessage();
};

const enableField = () => {
	if ( ! enableNode ) {
		return;
	}

	handle( enableNode );
	enableNode.addEventListener( 'change', function( event ) {
		handle( this );
	} );
};

const handle = ( enableNode ) => {
	const fieldWrapperNodes = document.querySelectorAll( '.wcbt-field-wrapper' );

	if ( ! fieldWrapperNodes ) {
		return;
	}
	const enableFieldWrapperNode = enableNode.closest( '.wcbt-field-wrapper' );
	for ( let i = 0; i < fieldWrapperNodes.length; i++ ) {
		const fieldWrapperNode = fieldWrapperNodes[ i ];
		if ( fieldWrapperNode === enableFieldWrapperNode ) {
			continue;
		}

		if ( enableNode.checked ) {
			fieldWrapperNode.style.display = 'flex';
			selectProductType();
		} else {
			fieldWrapperNode.style.display = 'none';
		}
	}
};

const handleEnableTooltip = ( productTypeNode ) => {
	const saleProductFieldNode = saleProductNode.closest( '.wcbt-field-wrapper' );
	const saleProductNumberFieldNode = saleProductNumberNode.closest( '.wcbt-field-wrapper' );
	const virtualProductFieldNode = virtualProductNode.closest( '.wcbt-field-wrapper' );
	const virtualUserFieldNode = virtualUserNode.closest( '.wcbt-field-wrapper' );
	if ( productTypeNode.value === 'sale-product' ) {
		saleProductFieldNode.style.display = 'flex';
		saleProductNumberFieldNode.style.display = 'flex';
		virtualProductFieldNode.style.display = 'none';
		virtualUserFieldNode.style.display = 'none';
	} else {
		saleProductFieldNode.style.display = 'none';
		saleProductNumberFieldNode.style.display = 'none';
		virtualProductFieldNode.style.display = 'flex';
		virtualUserFieldNode.style.display = 'flex';
	}
};

const selectProductType = () => {
	if ( ! productTypeNode ) {
		return;
	}

	handleEnableTooltip( productTypeNode );
	productTypeNode.addEventListener( 'change', function( event ) {
		handleEnableTooltip( this );
	} );
};

const insertVariableToMessage = () => {
	const messageNode = document.querySelector( '#wcbt_message' );
	if ( ! messageNode ) {
		return;
	}

	const items = messageNode.closest( '.wcbt-textarea-content' ).querySelectorAll( '.wcbt-description span' );

	[ ...items ].map( ( item ) => {
		item.addEventListener( 'click', function() {
			messageNode.value = messageNode.value + item.innerHTML;
		} );
	} );
};

export default wcbtSaleNotice;
